import { ChevronRightRounded, CopyAllRounded } from '@mui/icons-material';
import {
  Box, Button, CircularProgress, Container, Divider, LinearProgress,
} from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import AlertContext from '../../../../Context/AlertContext';
import ConfirmationContext from '../../../../Context/ConfirmationContext';
import { getUserItem } from '../../../../Redux/Models/box';
// import { isB2C } from '../../../../Utils/helpers';
import { getUserData } from '../../../../Utils/storages';
import Elements from '../../../Elements';
import Colors from '../../../../Configs/colors';
import dummy from '../../../../Configs/dummy';
import { copyToClipboard } from '../../../../Utils/helpers';

export default function ItemDetails({
  selectedItem, classes, error, message, isLoading,
}) {
  const user = getUserData();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { itemId } = useParams();
  const { t } = useTranslation();
  // const B2C = isB2C();

  const isBox = selectedItem.type === 'Box';
  const detail = isBox ? selectedItem?.box : selectedItem?.item ?? {};

  const { openAlert } = useContext(AlertContext);
  const { openConfirmation, closeConfirmation } = useContext(ConfirmationContext);

  useEffect(() => {
    if (itemId) {
      dispatch(getUserItem(user.id, itemId));
    }
  }, [itemId]);

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  const handleOpenReqOutModal = () => [
    openConfirmation({
      desc: 'Are you sure want to request out this item from cellar?',
      title: 'Requesting out this wine?',
      confirmText: 'Yes, request out',
      handleAgree: () => {
        navigate(`${ROUTES.requestOut()}`, { state: selectedItem });
        closeConfirmation();
      },
    }),
  ];

  return (
    <Elements.PageBase navigate={navigate} noNav>
      <Box className={classes.root}>
        <Elements.Navigator title={t('productDetails.title')} />
        {isLoading && <LinearProgress color="inherit" />}
        <Box textAlign="center" pt={isBox ? 0 : 2}>
          <img
            alt="wine"
            className={isBox ? 'cover' : 'cover rounded'}
            style={{
              width: isBox ? '100%' : '80%',
            }}
            src={detail?.photo || dummy.img}
          />
        </Box>
        {/* <Divider sx={{ borderColor: '#F5F6F8', borderWidth: 4, my: 2 }} /> */}
        <Container>
          <Box className="s-16 weight-700" textAlign="center" mt={2}>
            {detail.name}
          </Box>
          {isBox
            ? (
              <Box display="flex">
                <Box mt={1.5} flex={1}>
                  <Box className="s-10" fontWeight="400">{t('productDetails.capacity')}</Box>
                  <Box mt={0.25} className="s-12" fontWeight="700">12</Box>
                </Box>
                <Box mt={1.5} flex={1}>
                  <Box className="s-10" fontWeight="400">{t('marketPage.qty')}</Box>
                  <Box mt={0.25} className="s-12" fontWeight="700">
                    {detail?.amount}
                  </Box>
                </Box>
                <Box mt={1.5} flex={1}>
                  <Box className="s-10" fontWeight="400">{t('productDetails.inCellar')}</Box>
                  <Box mt={0.25} className="s-12" fontWeight="700">
                    {moment(detail?.marketed_on).format('DD MMM YYYY') || '-'}
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box display="flex">
                <Box flex={1}>
                  <Box mt={1.5}>
                    <Box className="s-10" fontWeight="400">{t('productDetails.category')}</Box>
                    <Box mt={0.25} className="s-12" fontWeight="700">{selectedItem.category?.name}</Box>
                  </Box>
                  <Box mt={1.5}>
                    <Box className="s-10" fontWeight="400">{t('productDetails.origin')}</Box>
                    <Box mt={0.25} className="s-12" fontWeight="700">-</Box>
                  </Box>
                  <Box mt={1.5}>
                    <Box className="s-10" fontWeight="400">{t('marketPage.qty')}</Box>
                    <Box mt={0.25} className="s-12" fontWeight="700">
                      1 Bottle
                    </Box>
                  </Box>
                </Box>
                <Box flex={1}>
                  <Box mt={1.5}>
                    <Box className="s-10" fontWeight="400">{t('productDetails.conditions')}</Box>
                    <Box mt={0.25} className="s-12" fontWeight="700">{selectedItem.condition?.name}</Box>
                  </Box>
                  <Box mt={1.5}>
                    <Box className="s-10" fontWeight="400">{t('productDetails.volume')}</Box>
                    <Box mt={0.25} className="s-12" fontWeight="700">
                      {detail?.volume || '0 mL'}
                    </Box>
                  </Box>
                  <Box mt={1.5}>
                    <Box className="s-10" fontWeight="400">{t('productDetails.inCellar')}</Box>
                    <Box mt={0.25} className="s-12" fontWeight="700">{moment(detail?.marketed_on).format('DD MMM YYYY')}</Box>
                  </Box>
                </Box>
                <Box flex={1}>
                  <Box mt={1.5}>
                    <Box className="s-10" fontWeight="400">{t('productDetails.year')}</Box>
                    <Box mt={0.25} className="s-12" fontWeight="700">{detail.year}</Box>
                  </Box>
                  <Box mt={1.5}>
                    <Box className="s-10" fontWeight="400">{t('productDetails.alcohol')}</Box>
                    <Box mt={0.25} className="s-12" fontWeight="700">-</Box>
                  </Box>
                </Box>
              </Box>
            )}

        </Container>
        <Divider sx={{ borderColor: '#F5F6F8', borderWidth: 4, my: 2 }} />
        <Container>
          <Box className="s-12" fontWeight="700">{t('productDetails.summary')}</Box>
          <Box display="flex">
            <Box flex={1}>
              <Box mt={1.5}>
                <Box className="s-10" fontWeight="400">{t('productDetails.reqId')}</Box>
                <Box mt={0.25} className="s-12" fontWeight="700" display="flex" alignItems="center" gap={1}>
                  {detail.request_id?.substr(0, 5)}
                  ...
                  <CopyAllRounded
                    fontSize="small"
                    className="link"
                    onClick={() => copyToClipboard(detail.request_id)}
                  />
                </Box>
              </Box>
              <Box mt={1.5}>
                <Box className="s-10" fontWeight="400">{t('productDetails.wineStatus')}</Box>
                <Box mt={0.25}>
                  <Box display="inline-flex" alignItems="center" gap={0.5} bgcolor="#FDE0E0" borderRadius={8} pr={1}>
                    <img src={Images.CheckRed} alt="check-icon" />
                    <div className="s-10 weight-600">Verified</div>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box flex={1}>
              <Box mt={1.5}>
                <Box className="s-10" fontWeight="400">{t('productDetails.wineId')}</Box>
                <Box mt={0.25} className="s-12" fontWeight="700" display="flex" alignItems="center" gap={1}>
                  {detail.id?.substr(0, 5)}
                  ...
                  <CopyAllRounded
                    fontSize="small"
                    className="link"
                    onClick={() => copyToClipboard(detail.id)}
                  />
                </Box>
              </Box>
              <Box mt={1.5}>
                <Box className="s-10" fontWeight="400">{t('productDetails.market')}</Box>
                <Box mt={0.25} className="s-12" fontWeight="700">
                  {detail.is_sale ? (
                    <Box display="inline-flex" alignItems="center" gap={0.5} bgcolor="#FDE0E0" borderRadius={8} pr={1}>
                      <img src={Images.CheckRed} alt="check-icon" />
                      <div className="s-10 weight-600">In Market</div>
                    </Box>
                  ) : '-'}
                </Box>
              </Box>
            </Box>
            <Box flex={1}>
              <Box mt={1.5}>
                <Box className="s-10" fontWeight="400">{t('productDetails.reqDate')}</Box>
                <Box mt={0.25} className="s-12" fontWeight="700">{moment(selectedItem.requested_at || detail.date_in).format('DD MMM YYYY (HH.mm)')}</Box>
              </Box>
            </Box>
          </Box>
          <Divider sx={{ my: 2 }} />
          <Box className="s-10" fontWeight="400">{t('common.notes')}</Box>
          <Box mt={0.25} className="s-12" fontWeight="600">
            {detail.notes || detail.pickup_notes || selectedItem.pickup_notes || '-'}
          </Box>
          <Box
            border="1px solid #F5F6F8"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            py={1}
            px={1.5}
            borderRadius={1}
            mt={1.5}
            onClick={() => navigate(`${ROUTES.history()}/${detail?.request_id}`)}
          >
            <Box className="weight-600 s-12">{t('productDetails.seeDetails')}</Box>
            <ChevronRightRounded />
          </Box>
        </Container>
        {!selectedItem.is_process && !detail?.is_sale
        && (
        <div className="floating-action">
          <Container>
            <Box display="flex" gap={1}>
              <Button
                variant="outlined"
                className="btn-outlined"
                fullWidth
                onClick={handleOpenReqOutModal}
                disabled={isLoading}
                startIcon={isLoading
                  && (<CircularProgress size={18} sx={{ mr: 1, color: Colors.primary }} />)}
              >
                {t('common.reqOut')}
              </Button>
              <Button
                variant="contained"
                className="btn-contained"
                fullWidth
                onClick={() => navigate(ROUTES.sellProduct(), { state: selectedItem })}
                disabled={isLoading || !selectedItem.type}
                startIcon={isLoading
                  && (<CircularProgress size={18} sx={{ mr: 1, color: '#fff' }} />)}
              >
                {t('productDetails.sell')}
              </Button>
            </Box>
          </Container>
        </div>
        )}
      </Box>
    </Elements.PageBase>
  );
}
